import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function TaekwondoNearMeFAQActions() {
  return <div className="text-center mt-12" data-id="element-3394">
      <p className="text-lg text-storm-red font-bold mb-4" data-id="element-3395">
        Still have questions?
      </p>
      <p className="text-gray-warm mb-6" data-id="element-3396">
        Contact us today for more information.
      </p>
      <Link to="/ContactUs.html" className="btn-secondary" data-id="element-3397">
        Contact <ArrowRight className="w-4 h-4 ml-2" data-id="element-3398" />
      </Link>
    </div>;
}